const initialState = {
	"pasoContasena": 0,
	"pasoPreguntas": 0,
	"pasoEliminar": 0,
	"pasoCodigo": 0,
	"password": "",
	"opcion": "",
	"razon": "",
	"editingDP": false,
	"editingCE": false,
	"editingRedes": false,
	"nombre": "Usuario Test",
	"usuario": "",
	"lada": "",
	"celular": "",
	"ladaFijo": "",
	"telefono": "",
	"ocupacion": "",
	"areaDeInteres": "",
	"nombreCE": "",
	"primerApellidoCE": "",
	"correoCE": "",
	"familiarResponsableCE": "",
	"ladaCE": "",
	"telefonoCE": "",
	"mensajeCE": "",
	"preguntaUno": "",
	"preguntaUnoText": "",
	"preguntaDos": "",
	"preguntaDosText": "",
	"encPasoTres": "",
	"msjPasoTres": "",
	"preguntaUnoEdit": "",
	"respuestaUnoEdit": "",
	"preguntaDosEdit": "",
	"respuestaDosEdit": "",
	"ife": "",
	"archivoIfe": "",
	"tarjetaCirculacion": "",
	"archivoTarjetaCirculacion": "",
	"licencia": "",
	"archivoLicencia": "",
	"msjEliminar": "",
	"encabezadoEliminar": "",
	"cuentaBorrada": false,
	"objTemporal": {},
	"oa": false,
	"ce": false,
	"docs": false,
	"rs": false,
	"facebook": "",
	"twitter": "",
	"google": "",
	"instagram": "",
	"porcentaje": 20,
	"newPass": "",
	"recibirConsejos": false,
	"recibirInformacion": false,
	"loadRedesSociales": false,
	"loadLocal": false,
	"idOperacion": 0,
	"codOtp": 0,
	"numCelOtp": 0,
	"correoOtp": "",
	"error": false,
	"muestraCodigoV": false
};

export function miPerfilRdc(state = initialState, action) {

	switch (action.type) {
		case "MI_PERFIL_PASO_SIGUIENTE_CONTRASENA":
			return {
				...state,
				"pasoContasena": state.pasoContasena + 1
			};
		case "MI_PERFIL_PASO_ANTERIOR_CONTRASENA":
			return {
				...state,
				"pasoContasena": state.pasoContasena - 1
			};
		case "MI_PERFIL_PASO_SIGUIENTE_PREGUNTAS":
			return {
				...state,
				"pasoPreguntas": state.pasoPreguntas + 1
			};
		case "MI_PERFIL_PASO_ANTERIOR_PREGUNTAS":
			return {
				...state,
				"pasoPreguntas": state.pasoPreguntas - 1
			};
		case "MI_PERFIL_PASO_SIGUIENTE_ELIMINAR":
			return {
				...state,
				"pasoEliminar": state.pasoEliminar + 1
			};
		case "MI_PERFIL_PASO_ANTERIOR_ELIMINAR":
			return {
				...state,
				"pasoEliminar": state.pasoEliminar - 1
			};
		case "MI_PERFIL_PASO_SIGUIENTE_CODIGO":
			return {
				...state,
				"pasoCodigo": state.pasoCodigo + 1
			};
		case "MI_PERFIL_PASO_ANTERIOR_CODIGO":
			return {
				...state,
				"pasoCodigo": state.pasoCodigo - 1
			};
		case "MI_PERFIL_RESET_SIGUIENTE_CONTRASENA":
			return {
				...state,
				"pasoContasena": 0
			};
		case "MI_PERFIL_RESET_SIGUIENTE_PREGUNTAS":
			return {
				...state,
				"pasoPreguntas": 0
			};
		case "MI_PERFIL_RESET_SIGUIENTE_ELIMINAR":
			return {
				...state,
				"pasoEliminar": 0
			};
		case "MI_PERFIL_GUARDAR_PASSWORD":
			return {
				...state,
				"password": action.password
			};
		case "MI_PERFIL_GUARDAR_OPCION":
			return {
				...state,
				"opcion": action.opcion
			};
		case "MI_PERFIL_GUARDAR_RAZON":
			return {
				...state,
				"razon": action.razon
			};

		case "MI_PERFIL_RESET_SIGUIENTE_CODIGO":
			return {
				...state,
				"pasoCodigo": 0
			};
		case "MI_PERFIL_SET_NEWPASS":
			return {
				...state,
				"newPass": action.newPass
			};
		case "MI_PERFIL_SET_P1":
			return {
				...state,
				"preguntaUno": action.id,
				"preguntaUnoText": action.p
			};
		case "MI_PERFIL_SET_P2":
			return {
				...state,
				"preguntaDos": action.id,
				"preguntaDosText": action.p
			};
		case "MI_PERFIL_SET_ENC":
			return {
				...state,
				"encPasoTres": action.text
			};
		case "MI_PERFIL_SET_MSJ":
			return {
				...state,
				"msjPasoTres": action.text
			};
		case "MI_PERFIL_SET_P1_EDIT":
			return {
				...state,
				"preguntaUnoEdit": action.p,
				"respuestaUnoEdit": action.r
			};
		case "MI_PERFIL_SET_P2_EDIT":
			return {
				...state,
				"preguntaDosEdit": action.p,
				"respuestaDosEdit": action.r
			};
		case "MI_PERFIL_SET_DOCUMENTOS_FLAG":
			return {
				...state,
				"docs": action.flag
			};
		case "MI_PERFIL_SET_IFE":
			var ban = false;
			var total = 20;
			if (state.oa) {
				total += 20;
			}
			if (state.ce) {
				total += 20;
			}
			if (state.rs) {
				total += 20;
			}
			if (action.img != "" || state.tarjetaCirculacion != "" || state.licencia != "") {
				ban = true;
				total += 20;
			}
			return {
				...state,
				"docs": ban,
				"ife": action.img,
				"porcentaje": total
			};
		case "MI_PERFIL_SET_TC":
			var ban = false;
			var total = 20;
			if (state.oa) {
				total += 20;
			}
			if (state.ce) {
				total += 20;
			}
			if (state.rs) {
				total += 20;
			}
			if (action.img != "" || state.ife != "" || state.licencia != "") {
				ban = true;
				total += 20;
			}
			return {
				...state,
				"docs": ban,
				"tarjetaCirculacion": action.img,
				"porcentaje": total
			};
		case "MI_PERFIL_SET_LIC":
			var ban = false;
			var total = 20;
			if (state.oa) {
				total += 20;
			}
			if (state.ce) {
				total += 20;
			}
			if (state.rs) {
				total += 20;
			}
			if (action.img != "" || state.ife != "" || state.tarjetaCirculacion != "") {
				ban = true;
				total += 20;
			}
			return {
				...state,
				"docs": ban,
				"licencia": action.img,
				"porcentaje": total
			};
		case "MI_PERFIL_SET_MSJ_ELIMINAR":
			return {
				...state,
				"msjEliminar": action.msj
			};
		case "MI_PERFIL_SET_ENCABEZADO_ELIMINAR":
			return {
				...state,
				"encabezadoEliminar": action.msj
			};
		case "MI_PERFIL_SET_CUENTA_BORRADA":
			return {
				...state,
				"cuentaBorrada": action.valor
			};
		case "MI_PERFIL_SET_DATOS_PERSONALES_FLAG":
			return {
				...state,
				"oa": action.flag
			};
		case "MI_PERFIL_SET_DATOS_PERSONALES":
			var total = 20;
			var ban = false;
			if (state.ce) {
				total += 20;
			}
			if (state.docs) {
				total += 20;
			}
			if (state.rs) {
				total += 20;
			}
			if (action.ocupacion != "" && action.areaDeInteres != "") {
				ban = true;
				total += 20;
			}
			return {
				...state,
				"oa": ban,
				"ocupacion": action.ocupacion,
				"areaDeInteres": action.areaDeInteres,
				"porcentaje": total
			};
		case "MI_PERFIL_SET_DT_USUARIO":
			return {
				...state,
				"usuario": action.usuario
			};
		case "MI_PERFIL_SET_DT_TFIJO":
			return {
				...state,
				"ladaFijo": action.ladaFijo,
				"telefono": action.telefono
			};
		case "MI_PERFIL_SET_DT_TCELULAR":
			return {
				...state,
				"lada": action.lada,
				"celular": action.celular
			};
		case "MI_PERFIL_SET_CONTACTO_EMERGENCIA_FLAG":
			return {
				...state,
				"ce": action.flag
			};
		case "MI_PERFIL_SET_CONTACTO_EMERGENCIA":
			var total = 20;
			if (state.oa) {
				total += 20;
			}
			if (state.ce) {
				total += 20;
			}
			if (state.docs) {
				total += 20;
			}
			if (state.rs) {
				total += 20;
			}
			return {
				...state,
				"ce": true,
				"nombreCE": action.nombre,
				"primerApellidoCE": action.primerApellido || "",
				"correoCE": action.correo || "",
				"familiarResponsableCE": action.familiarResponsable || "",
				"otroEspecifiqueCE": action.otroEspecifique || "",
				"ladaCE": action.lada,
				"telefonoCE": action.telefono,
				"mensajeCE": action.mensaje,
				"porcentaje": total
			};
		case "MI_PERFIL_SET_OBJ_TEMPORAL":
			return {
				...state,
				"objTemporal": action.obj
			};
		case "MI_PERFIL_RESET_OBJ_TEMPORAL":
			return {
				...state,
				"objTemporal": {}
			};
		case "MI_PERFIL_CHANGE_EDITING_DP":
			return {
				...state,
				"editingDP": action.flag
			};
		case "MI_PERFIL_CHANGE_EDITING_CE":
			return {
				...state,
				"editingCE": action.flag
			};
		case "MI_PERFIL_SET_REDES_FLAG":
			return {
				...state,
				"rs": action.flag
			};
		case "MI_PERFIL_SET_REDES":
			var total = 20;
			var ban = false;
			if (state.oa) {
				total += 20;
			}
			if (state.ce) {
				total += 20;
			}
			if (state.docs) {
				total += 20;
			}
			if (action.facebook != "" || action.twitter != "" || action.google != "" || action.instagram) {
				ban = true;
				total += 20;
			}
			return {
				...state,
				"rs": ban,
				"facebook": action.facebook,
				"twitter": action.twitter,
				"google": action.google,
				"instagram": action.instagram,
				"porcentaje": total
			};
		case "MI_PERFIL_SET_PREGUNTAS":
			return {
				...state,
				"preguntaUno": action.id1,
				"preguntaUnoText": action.p1,
				"preguntaDos": action.id2,
				"preguntaDosText": action.p2
			};
		case "MI_PERFIL_SET_DOCUMENTOS":
			return {
				...state,
				"archivoIfe": action.ife,
				"archivoTarjetaCirculacion": action.tc,
				"archivoLicencia": action.lic
			};
		case "MI_PERFIL_SET_ARCHIVO_IFE":
			return {
				...state,
				"archivoIfe": action.ife,
			};
		case "MI_PERFIL_SET_ARCHIVO_TC":
			return {
				...state,
				"archivoTarjetaCirculacion": action.tc,
			};
		case "MI_PERFIL_SET_ARCHIVO_LIC":
			return {
				...state,
				"archivoLicencia": action.lic,
			};
		case "MI_PERFIL_SET_RECIBIR_INFO":
			return {
				...state,
				"recibirInformacion": action.info
			};
		case "MI_PERFIL_SET_RECIBIR_CONSEJOS":
			return {
				...state,
				"recibirConsejos": action.consejos
			};
		case "MI_PERFIL_SET_LOAD_RSOCIALES":
			return {
				...state,
				"loadRedesSociales": action.load
			};
		case "MI_PERFIL_SET_LOAD_LOCAL":
			return {
				...state,
				"loadLocal": action.load
			};
		case "MI_PERFIL_SET_OPERACION":
			return {
				...state,
				"idOperacion": action.idOperacion,
				"codOtp": action.codOtp
			};
		case "MI_PERFIL_SET_DATOS_OTP":
			return {
				...state,
				"numCelOtp": action.numero,
				"correoOtp": action.correo,
				"tokenItm": action.tokenItm,
			};
		case "MI_PERFIL_VALIDACION_CODIGO_MOVIL":
			return {
				...state,
				"muestraCodigoV": action.muestraCodigoV
			};
		case "MI_PERFIL_SET_ERROR":
			return {
				...state,
				"error": action.error
			};
		case "MI_PERFIL_SET_EVENT":
			return {
				...state,
				"evento": action.evento
			};
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/miPerfil/reducer.js